import React, { Component } from 'react';
import ImageUploader from 'react-images-upload';

export class ImageEdit extends Component {

    constructor(props) {
        super(props);
        this.onDrop = this.onDrop.bind(this);    
    }


    onDrop(pic) {
        var reader = new FileReader();
        reader.readAsDataURL(pic[0]);
        reader.onloadend = () => {
            this.props.onDrop(reader.result);            
        };       
       
    }
    render() {

        return (
            <div className="m15">
                <ImageUploader
                    withIcon={false}
                    buttonText='choose image'
                    onChange={this.onDrop}
                    imgExtension={['.png']}
                    maxFileSize={5242880}
                    singleImage={true}
                    label='Max file size: 5mb, accepted: png'
                />
            </div>
        );
    }
}

